import { gql, TypedDocumentNode } from '@apollo/client';
import type { InventoryItem } from '../models/InventoryItem';

export const GET_INVENTORYITEMS_QUERY: TypedDocumentNode<{ inventoryItems: InventoryItem[] }> = gql`
  query GetInventoryItems {
    inventoryItems {
      id,
      quantityOnHand,
      quantityOrdered,
      costPerUnit,
      lotNumber,
      surchargePerUnit,
      shippingCostPerUnit,
      surchargeOrDiscount,
      totalCostPerUnit,
      totalOrderedCost,
      orderDetails,
      itemId,
      item {
        id,
        name,
        unitType,
        isIngredient,
        description,
        orderNotes,
        standardShippingQuantity,
        minOrderQuantity,
        maxOrderQuantity,
        lowStock,
        outOfStock
      },
      vendorId,
      vendor {
        id,
        name
      },
      purchaseOrderId,
      purchaseOrder {
        id,
        dateTimePurchased
      }
    }
  }
`;

export const GET_INVENTORYITEM_BY_ID_QUERY: TypedDocumentNode<{ inventoryItem: InventoryItem }, { id: number }> = gql`
  query GetInventoryItemById($id: Int!) {
    inventoryItem: inventoryItemById(id: $id) {
      id,
      quantityOnHand,
      quantityOrdered,
      costPerUnit,
      lotNumber,
      surchargePerUnit,
      shippingCostPerUnit,
      surchargeOrDiscount,
      totalCostPerUnit,
      totalOrderedCost,
      orderDetails,
      itemId,
      item {
        id,
        name,
        unitType,
        isIngredient,
        description,
        orderNotes,
        standardShippingQuantity,
        minOrderQuantity,
        maxOrderQuantity,
        lowStock
        outOfStock
      },
      vendorId,
      vendor {
        id,
        name
      },
      purchaseOrderId,
      purchaseOrder {
        id,
        dateTimePurchased
      },
      consumedInventoryItems {
        id,
        batchId,
        batch {
          id,
          lotNumber,
          dateTimeCreated
        },
        quantityNeeded,
        quantityUsed,
        totalProductBatchQuantity,
        totalItemCost
      },
      attachments {
        id,
        name,
        relativePath
      }
    }
  }
`;
